module.exports = __webpack_public_path__ + "static/media/007.10863d31.jpg";